export default {
  env: 'production' as const,
  checkout: 'pk_1d8129af-2e3e-4a59-b630-2b47980911e2',
  hostname: 'https://api.marshmallow.com',
  appUrl: 'https://www.marshmallow.com',
  pcaapikey: 'YK78-PW79-XX19-WX31',
  segmentkey: 'BWqidcLkaM6FiKadb4QM0ZdpFgfx9Xte',
  intercomKey: 'segl9g2z',
  ravelinKey: 'publishable_key_live_fYkIkXFVt1iSH72kqrAgUywIWVUpZKdG',
  ravelinCookieDomain: '.marshmallow.com',
  confusedTrackingUrl: 'https://follow.confused.com',
  customerAccount: 'https://account.marshmallow.com',
  plaidEnv: 'production',
  plaidPublicKey: 'c972a242afdd539c5c38d6b35feb1f',
  plaidWebhook: 'https://api.marshmallow.com/open-banking/updates',
  timeout: 45000,
  rollouts: 'Fv2vKtcS71x5847NKWpEe',
  datadog: {
    environment: 'production',
    applicationId: 'd017fa8e-834f-405c-a202-908d90128ca3',
    clientToken: 'pub41913af2956aabe4dd3bd2a1457b378d',
    traces: {
      enabled: true,
    },
  },
  sentry: {
    dns: 'https://7c4f289146c642ea8cdcae4ddf4e1587@o326695.ingest.sentry.io/6066978',
  },
}
